import { FaCheck, FaIdCard, FaTruckMoving } from "react-icons/fa";
import "./styles.scss";

const conductorRequirements = [
	"Cédula legible, no contraseña",
	"Licencia de conducción vigente",
	"Planilla de pago de seguridad social: EPS y ARL",
	"Dirección y teléfono de residencia",
	"Referencia familiar con teléfono",
	"Dos referencias de empresas: contacto, cargo y teléfono",
	"Cuenta bancaria",
	"Experiencia mínima de 2 años para vehículos articulados",
	"Curso HSE para transporte de líquidos",
	"Copia del RUT",
];

const vehicleRequirements = [
	"Licencia de tránsito",
	"Seguro obligatorio SOAT vigente",
	"Revisión técnico-mecánica y de gases",
	"Vehículos con más de 30 años deben estar repotenciados a 10 años o menos",
	"Tiquete de báscula del peso vacío con máximo una semana de antigüedad",
	"Sistema satelital del vehículo: GPS",
	"Contrato de compraventa, si aplica",
];

const RequirementList = ({ icon, title, items }) => {
	return (
		<div className="requirement_card">
			<div className="requirement_head">
				<span>{icon}</span>
				<h3>{title}</h3>
			</div>
			<ul>
				{items.map((item) => (
					<li key={item}>
						<FaCheck />
						<span>{item}</span>
					</li>
				))}
			</ul>
		</div>
	);
};

const Aliados = () => {
	return (
		<section className="aliados">
			<div
				className="aliados_banner"
				style={{
					backgroundImage:
						'linear-gradient(90deg, rgba(11, 36, 54, 0.46), rgba(11, 36, 54, 0.08)), url("/images/aliado.jpg")',
				}}
			>
				<div>
					<span>ALIADOS / TRANSPORTADORES</span>
					<h1>Requisitos para transportar con ForzaKargo</h1>
					<p>
						Buscamos aliados confiables para operaciones de carga seca en ciudades y puertos del país.
					</p>
				</div>
			</div>

			<div className="aliados_intro">
				<p>
					Para <strong>TRANSPORTES FORZAKARGO S.A.S.</strong> es muy importante contar con su participación
					en el desarrollo de nuestras operaciones. Contamos con ofertas de carga para
					<strong> tractomulas, dobletroques, minimulas, sencillos y turbos</strong>.
				</p>
				<p>
					Trabajamos para ofrecer asignación oportuna de viajes, fletes acordes al mercado, pago de anticipos,
					saldos a tiempo y atención a novedades en ruta a nivel nacional.
				</p>
			</div>

			<div className="requirements_grid">
				<RequirementList icon={<FaIdCard />} title="Conductor" items={conductorRequirements} />
				<RequirementList icon={<FaTruckMoving />} title="Vehículo" items={vehicleRequirements} />
			</div>
		</section>
	);
};

export default Aliados;
